define(['app', 'underscore', 'libs/models/UserModel', './index.html', 'utils/userAvatar'], function (
  app,
  _,
  UserModel,
  tmplAvatar,
  userAvatar
) {
  return app.Marionette.ItemView.extend({
    template: tmplAvatar,

    tagName: 'div',

    options: {
      size: 's'
    },

    attributes: function () {
      var size = this.getOption('size') || 's'
      var existingClass = this.$el ? this.$el.prop('class') : ''
      return {
        class: ['avatar', 'avatar--' + size, existingClass].join(' ')
      }
    },

    templateHelpers: function () {
      return {
        showRank: this.options.showRank !== false,
        isDefaultAvatar: userAvatar.isDefaultAvatar(this.model.get('avatar')),
        avatarInital: userAvatar.getAvatarInital(this.model.get('name')),
        generatedAvatarClass: userAvatar.getAvatarClass(this.model.get('id'))
      }
    },

    initialize: function (options) {
      this.$el.attr(this.attributes())
      this.model = this.model || new UserModel(options.user || {})
    }
  })
})
